import { render, staticRenderFns } from "./PageRestrictions.vue?vue&type=template&id=46cf6db9"
import script from "./PageRestrictions.vue?vue&type=script&lang=js"
export * from "./PageRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports